import * as React from 'react'
import { keys } from 'lodash'
import Errors from './errors'
import FormGroup from './form-group'
import InputLabel from './input-label'
import './yes-no-input.css'


export default class YesNoInput extends React.Component<any, any>{


  

    render(){
        const props = this.props;
        
        const field = props.field;
        const label = props.label;
        const value = props.value;
        const errors = props.errors;
        const updateField = props.updateField;
        const reverse = this.props.reverse;
        const show = props.show;
        const help = props.help;

        const yesValue = reverse ? false : true;
        const noValue = reverse ? true : false;
        
        if(show == null || show){
            return (
                <div className="col-12">
                    <FormGroup className="form-group-yes-no" field={ field } errors={ errors }>
                        <div className="to-justify">
                            <InputLabel className="yes-no-label" field={ field } label={ label } help={ help }/>
                            <div className="yes-no-selections" id={ field.replace(".", "-") }>
                                { value }
                                <span className="yes-no-option">
                                    <label htmlFor={field+"-yes"}>Yes</label>
                                    <input id={field + "-yes"} type="radio" name={field} checked={ value===yesValue } onChange={e => updateField(field, yesValue)}/>
                                </span>
                                <span className="yes-no-option">
                                    <label htmlFor={field+"-no"}>No</label>
                                    <input id={field + "-no"} type="radio" name={field} checked={ value===noValue } onChange={e => updateField(field, noValue)}/>
                                </span>
                                
                            </div>
                        </div>
                        <Errors errors={ errors } />
                    </FormGroup>
                </div>
            )
        }else{
            return null;
        }
    }

}


    

    



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/yes-no-input.tsx